import APIService from './APIService';

export default {
  getAtualizacoes() {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get('/atualizacoes-bdgd-via-sql/get-atualizacoes')
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error));
    });
  },
  save(data) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .post('/atualizacoes-bdgd-via-sql/salvar', JSON.stringify(data))
        .then(() => resolve(true))
        .catch(() => reject(false));
    });
  },
  deletar(id) {
    return APIService.apiCall().get(`/atualizacoes-bdgd-via-sql/excluir/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/atualizacoes-bdgd-via-sql/executar/${id}`);
  },
  baixarZip(id, config = {}) {
    return APIService.apiCall().get(`/atualizacoes-bdgd-via-sql/download-arquivo-zip-logs/${id}`, {
      responseType: 'blob',
      ...config
    });
  }
};
